import React from 'react';
import Publish from './Publish';

const MyCourse = () => {

    return (
                <div className="drawer drawer-mobile">
                    <Publish></Publish>
                </div>
    );
};

export default MyCourse;